import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  Switch,
  TextField,
} from '@material-ui/core';
import Autocomplete from '@mui/material/Autocomplete';
import CardContent from '@mui/material/CardContent';
import { FormProvider, useForm } from 'react-hook-form';
import { StructuredMetadataTable } from '@backstage/core-components';

interface KmsCardEditDialogProps {
  accountName: [];
  kmsEnabled: boolean | undefined;
  setKmsEnabled: (enabled: boolean | undefined) => void;
  standardAccountList: any[] | undefined;
  setStandardAccountList: (list: any[] | undefined) => void;
  attributeAccountList: any[] | undefined;
  setAttributeAccountList: (list: any[] | undefined) => void;
  handleKmsToggle: () => void;
  isConfirmDialogOpen: boolean;
  handleConfirmDialogNo: () => void;
  handleConfirmDialogYes: () => void;
}

export const KmsCardEditDialog = ({
  accountName,
  kmsEnabled,
  standardAccountList,
  setStandardAccountList,
  attributeAccountList,
  setAttributeAccountList,
  handleKmsToggle,
  isConfirmDialogOpen,
  handleConfirmDialogNo,
  handleConfirmDialogYes,
}: KmsCardEditDialogProps) => {
  const formContext = useForm({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    shouldFocusError: true,
    shouldUnregister: false,
    defaultValues: ['1234567890'],
  });

  return (
    <CardContent>
      <FormProvider {...formContext}>
        <Grid container spacing={4}>
          <Grid item xs={6}>
            <StructuredMetadataTable
              metadata={{
                'Standard KMS Key Enabled': 'Enabled',
              }}
            />
            <Divider />
            <div style={{ marginTop: '4.5px' }}>
              <strong>Account IDs with Decrypt Access</strong>
              <Autocomplete
                multiple
                id="standard-account-name"
                options={accountName}
                disableCloseOnSelect
                value={standardAccountList || []}
                renderOption={(props, option) => (
                  <li style={{ wordWrap: 'break-word' }} {...props}>
                    {option}
                  </li>
                )}
                renderInput={params => (
                  <TextField
                    {...params}
                    label="Account IDs"
                    placeholder="Account IDs"
                    style={{ backgroundColor: '#ffffff' }}
                  />
                )}
                onChange={(_event, value) => {
                  setStandardAccountList(
                    value.map((ele: any) => ele.split(' : ')[0]),
                  );
                }}
              />
            </div>
          </Grid>
          <Grid item xs={6}>
            <StructuredMetadataTable
              metadata={{
                'Attribute KMS Key Enabled': (
                  <Switch
                    id="kms-atrribute-enabled"
                    name="kms-atrribute-enabled"
                    checked={kmsEnabled || false}
                    onChange={handleKmsToggle}
                    size="small"
                  />
                ),
              }}
            />
            <Divider />
            {kmsEnabled === true ? (
              <div>
                <strong>Account IDs with Decrypt Access</strong>
                <Autocomplete
                  multiple
                  id="attribute-account-name"
                  options={accountName}
                  value={attributeAccountList || []}
                  disableCloseOnSelect
                  onChange={(_event, value) => {
                    setAttributeAccountList(
                      value.map((ele: any) => ele.split(' : ')[0]),
                    );
                  }}
                  renderOption={(props, option) => <li {...props}>{option}</li>}
                  renderInput={params => (
                    <TextField
                      {...params}
                      label="Account IDs"
                      placeholder="Account IDs"
                      style={{ backgroundColor: '#ffffff' }}
                    />
                  )}
                />
              </div>
            ) : null}
          </Grid>
        </Grid>
      </FormProvider>
      {kmsEnabled === false ? (
        <Dialog open={isConfirmDialogOpen}>
          <DialogTitle>Confirm Disabling KMS Keys</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to disable the attribute key? Disabling it
              will delete the key.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleConfirmDialogNo} color="primary">
              No
            </Button>
            <Button onClick={handleConfirmDialogYes} color="primary">
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      ) : null}
    </CardContent>
  );
};
